/**
 * Pont entre l'en-tête AYA et le reste du thème.
 * 1. Menu mobile : le tiroir du menu est déplacé à la racine de la page pour ne plus être rogné
 *    par l'en-tête quand celui-ci est en mode transparent (page d'accueil).
 * 2. Panier : l'en-tête AYA n'utilise pas le composant <cart-icon> d'origine. Sans lui, rien n'ouvrait le panier
 *    après un ajout et le compteur ne bougeait pas. Ce fichier remet ce comportement en place.
 *
 * Script classique (pas un module) : il ne dépend d'aucun autre fichier du thème pour fonctionner.
 */
(function () {
  'use strict';

  /* ---------- Menu mobile ---------- */

  function portalMenuDrawers() {
    document.querySelectorAll('.aya-header [data-aya-drawer]').forEach(function (drawer) {
      // Éditeur de thème : si la section est rechargée, on retire l'ancien tiroir déjà déplacé
      if (drawer.id) {
        document.querySelectorAll('body > [data-aya-drawer]').forEach(function (old) {
          if (old !== drawer && old.id === drawer.id) old.remove();
        });
      }

      drawer.classList.add('aya-section');
      document.body.appendChild(drawer);
    });
  }

  try {
    portalMenuDrawers();
    document.addEventListener('shopify:section:load', portalMenuDrawers);
  } catch (error) {
    console.error('AYA menu :', error);
  }

  /* ---------- Panier ---------- */

  var behavior = window.ayaAddToCartBehavior || 'open_cart';
  var silentSources = ['cart-reservation-timer'];
  var editSources = ['cart-drawer-item', 'cart-discount', 'cart-note'];
  var cartUrl = '/cart';
  var toastMessage = 'Produit ajouté au panier';

  try {
    // "Theme" est déclaré par le thème dans snippets/scripts.liquid
    if (typeof Theme !== 'undefined' && Theme) {
      if (Theme.routes && Theme.routes.cart_url) cartUrl = Theme.routes.cart_url;
      if (Theme.translations && Theme.translations.addToCartNotificationMessage) {
        toastMessage = Theme.translations.addToCartNotificationMessage;
      }
    }
  } catch (error) {}

  function getDrawer() {
    var drawer = document.querySelector('cart-drawer');
    return drawer && typeof drawer.open === 'function' ? drawer : null;
  }

  function openCart() {
    var drawer = getDrawer();
    if (!drawer) return false;
    drawer.open();
    return true;
  }

  function showToast() {
    document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'success', message: toastMessage } }));
  }

  function setCount(count) {
    document.querySelectorAll('.aya-header__cart').forEach(function (link) {
      var badge = link.querySelector('.aya-header__count');

      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'aya-header__count';
          link.appendChild(badge);
        }
        badge.textContent = count;
        badge.hidden = false;
      } else if (badge) {
        badge.hidden = true;
      }

      link.setAttribute('aria-label', 'Panier (' + count + ')');
    });
  }

  var nativeFetch = window.fetch.bind(window);

  function refreshCount() {
    nativeFetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
      })
      .catch(function () {});
  }

  var refreshTimer;
  function scheduleRefresh() {
    refreshCount();
    clearTimeout(refreshTimer);
    // Le panier peut encore être modifié juste après (cadeaux automatiques) : on relit le vrai total
    refreshTimer = setTimeout(refreshCount, 1200);
  }

  // Retour visuel pour la cliente, une seule fois par ajout
  var lastFeedback = 0;
  function giveFeedback() {
    var now = Date.now();
    if (now - lastFeedback < 1500) return;
    lastFeedback = now;

    if (behavior === 'notification') {
      showToast();
      return;
    }

    // Laisse le temps au panier latéral de se mettre à jour, puis l'ouvre
    setTimeout(function () {
      if (!openCart()) showToast();
    }, 150);
  }

  // Clic sur l'icône panier de l'en-tête : ouvre le panier latéral (sinon le lien vers /cart fonctionne normalement)
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('.aya-header__cart') : null;
    if (!link) return;
    if (openCart()) event.preventDefault();
  });

  // Voie 1 : l'événement du thème émis après chaque modification du panier
  document.addEventListener('cart:updated', function (event) {
    var data = (event.detail && event.detail.data) || {};

    if (typeof data.itemCount === 'number') setCount(data.itemCount);
    scheduleRefresh();

    if (silentSources.indexOf(data.source) !== -1) return;
    if (editSources.indexOf(data.source) !== -1) return;

    giveFeedback();
  });

  // Voie 2 (filet de sécurité) : on surveille directement les appels au panier Shopify.
  // Fonctionne même si l'événement du thème n'est pas émis ou si une app ajoute au panier.
  window.fetch = function (input, init) {
    var promise = nativeFetch(input, init);

    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();

      if (method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        var isAdd = /\/cart\/add/.test(url);

        promise
          .then(function (response) {
            if (!response || !response.ok) return;
            scheduleRefresh();
            if (isAdd) giveFeedback();
          })
          .catch(function () {});
      }
    } catch (error) {}

    return promise;
  };

  // Compteur juste dès l'arrivée sur la page (utile si la page vient du cache)
  refreshCount();

  console.log('AYA : pont panier chargé (' + behavior + ')');
})();
